export const firebaseConfig = {
    apiKey: "AIzaSyAdk_OwlN5lNt-viG5bS3wOxfsXmd5xZnE",
    authDomain: "woowa-33196.firebaseapp.com",
    projectId: "woowa-33196",
    storageBucket: "woowa-33196.appspot.com",
    messagingSenderId: "522521462459",
    appId: "1:522521462459:web:0ab86a9123cd75370c4b9e",
    measurementId: "G-SWDP415KGZ"
  };